/* /connect?device=<id>&claim=<secret> — opened by Brightivity Helper on this computer (first run, or its tray menu
 * "Open Brightivity"). Remembers the Helper as "this computer" for this browser and links it to the signed-in account
 * (POST /bridge/devices/claim), then goes to Print. No browser permission is involved. */
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { claimComputer } from '../api/bridge.js';
import { rememberLocalDevice } from '../api/localHelper.js';
import { TopBar } from '../app/AppShell.jsx';
import { Button, Card, EmptyState, Spinner } from '../ui/index.jsx';

export default function ConnectPage() {
  const { t } = useTranslation('bv');
  const [params] = useSearchParams();
  const nav = useNavigate();
  const once = useRef(false);
  const [state, setState] = useState({ busy: true });
  const device = (params.get('device') || '').trim();
  const claim = (params.get('claim') || '').trim();
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    if (!/^dev_[A-Za-z0-9]{3,}$/.test(device) || claim.length < 16) { setState({ error: t('connect.badLink') }); return; }
    rememberLocalDevice(device, claim);
    claimComputer(device, claim).then((r) => {
      if (r.ok) { setState({ done: r.data.device }); setTimeout(() => nav('/print', { replace: true }), 900); } else setState({ error: r.error });
    });
  }, [device, claim]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="bv-content">
      <TopBar title={t('connect.title')} subtitle={t('connect.subtitle')} />
      <Card data-testid="connect-page">
        {state.busy ? <Spinner /> : state.done ? (
          <EmptyState icon="check" title={t('computers.connect.connected', { name: state.done.name })} action={<Button as={Link} to="/print" variant="coral">{t('connect.toPrint')}</Button>}>{t('connect.done')}</EmptyState>
        ) : (
          <EmptyState icon="print" title={t('connect.failed')} action={<Button as={Link} to="/print" variant="blue">{t('connect.toPrint')}</Button>}>{state.error}</EmptyState>
        )}
      </Card>
    </div>
  );
}
